module.exports = __webpack_public_path__ + "static/img/datashare3.a2024700.png";